module.exports = __webpack_public_path__ + "static/media/bi_mascot_vic_and_ddory.8b36e85a.png";